function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "#fff"
}, React.createElement("circle", {
  cx: 552,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 546.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 514,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 500.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 496.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 495,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 495,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 475.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 472.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 470.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 467.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 465.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 465.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 463.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 456.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 455.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 455.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 455.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 451.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 448.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 446.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 444.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 444.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 443.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 439.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 439.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 437.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 437.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 437.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 434.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 434.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 434.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 434.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 434.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 425.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 424.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 422.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 420.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 418.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 417.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 413.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 413.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 412,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 410.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 408.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 406.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 406.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 406.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 403.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 396.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 396.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 396.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 393,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 393,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 391.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 391.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 389.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 384.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 379.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 375.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 374,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 372.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 370.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 368.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 365.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 363.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 361.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 358.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 355,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 353.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 351.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 349.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 349.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 348,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 348,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 346.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 344.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 339.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 337.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 332.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 329,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 316.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 315.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 313.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 311.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 310,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 301.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 287.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 282.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 282.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 272,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 268.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 268.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 266.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 261.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 259.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 258.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 254.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 251.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 240.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 237.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 230.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 228.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 225.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 223.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 220.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 216.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 216.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 216.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 214.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 213.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 209.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 204.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 187.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 182.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 176.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 173.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 173.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 173.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 171.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 164.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 163.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 161.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 157.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 149.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 133.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 133.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 123.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 116.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 107.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 107.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 100.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 54.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 54.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 47.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 45.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 30,
  cy: 62,
  r: 30,
  opacity: 0.03
}));

var SvgCountryFigures03 = function SvgCountryFigures03(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 582 124",
    style: {
      backgroundColor: "#0d5b61"
    }
  }, props), _ref);
};

export default SvgCountryFigures03;